import React from 'react';

export interface SecurityContextContent {
  accessToken?: string;
  setAccessToken?: (string) => void;
  organizationId?: string,
  setOrganizationId?: (string) => void,
}

export default React.createContext<SecurityContextContent>({
  accessToken: undefined,
  setAccessToken: undefined,
  organizationId: undefined,
  setOrganizationId: undefined,
});
